module.exports = __webpack_public_path__ + "img/icon-help.b829009e.svg";